import React from "react";
import { ManageInvestmentsPlanContainer } from "../../../containers";

const ManageInvestmentsPlan = (props) => {
  return <ManageInvestmentsPlanContainer {...props} />;
};

export default ManageInvestmentsPlan;
